// Cognito user pool for the GRC tool. These values are not secrets: an app client
// created WITHOUT a client secret is meant to be shipped in frontend code.
// Set them in .env.local (see .env.example) when REACT_APP_AUTH_MODE=cognito.

export const AUTH_MODE = process.env.REACT_APP_AUTH_MODE || "demo";

export const COGNITO = {
  region: process.env.REACT_APP_COGNITO_REGION || "us-east-1",
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "",
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "",
};
